/**
 * This file was auto-generated by Fern from our API Definition.
 */

/**
 * Enum value descriptor.
 */
export interface ClaimsSchemaEnumValue {
    /** The human-readable name of the enum value. */
    title?: string;
    /** The value of the enum. */
    value: string;
}
